import { render } from "./InteractionViewer.vue?vue&type=template&id=4a9dd8a8&scoped=true"
import script from "./InteractionViewer.vue?vue&type=script&lang=js"
export * from "./InteractionViewer.vue?vue&type=script&lang=js"

import "./InteractionViewer.vue?vue&type=style&index=0&id=4a9dd8a8&lang=scss&scoped=true"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9dd8a8"]])

export default __exports__